import React from "react";
import Hero from "../components/sections/Hero";
import MarqueeBar from "../components/sections/Marquee";
import HowItWorks from "../components/sections/HowItWorks";
import Different from "../components/sections/Different";
import WhereToPlay from "../components/sections/WhereToPlay";
import TheCards from "../components/sections/TheCards";
import WhyLoveIt from "../components/sections/WhyLoveIt";
import WhatsInTheBox from "../components/sections/WhatsInTheBox";
import PreLaunch from "../components/sections/PreLaunch";
import FAQ from "../components/sections/FAQ";
import EmailCapture from "../components/sections/EmailCapture";

const Home = () => {
  return (
    <main data-testid="home-page">
      <Hero />
      <MarqueeBar />
      <HowItWorks />
      <Different />
      <WhereToPlay />
      <TheCards />
      <WhyLoveIt />
      <WhatsInTheBox />
      <PreLaunch />
      <FAQ />
      <EmailCapture />
    </main>
  );
};

export default Home;
